import React from 'react';
import './SplitterHelperModal.css';

export default function SplitterHelperModal({ onClose }) {
  return (
    <div className="splitter-modal-overlay">
      <div className="splitter-modal-card">
        <h2>📘 How It Works</h2>
        <p>This tool helps you break down long-form content like transcripts or articles into manageable parts.</p>
        <ol>
          <li>🧩 Use <strong>Split Text</strong> to divide text into labeled chunks — perfect for ChatGPT or similar tools with input limits.</li>
          <li>📺 Use <strong>Split Text with YouTube Prompt</strong> to optimize summaries for YouTube or podcast transcripts using a smart prompt.</li>
          <li>📋 Easily copy each chunk or use <strong>Copy All</strong> for bulk copying.</li>
        </ol>

        <h3>🧠 Summary Option</h3>
        <p><strong>Summary</strong> generates a quick, AI-powered digest of your text to speed up review and comprehension.</p>

        <h3>🙋‍♂️ About This Tool</h3>
        <p>
          <strong>ProdPilot</strong> was built to help creators and freelancers manage overwhelming transcripts without burnout.
        </p>
        <p>
          If this helps you too, consider <a href="https://buymeacoffee.com/prodpilot" target="_blank" rel="noopener noreferrer" className="inline-coffee-link">buying me a coffee</a> ☕ — it really helps support future updates.
        </p>

        <button onClick={onClose} className="splitter-modal-close">Close</button>
      </div>
    </div>
  );
}
